import { render, staticRenderFns } from "./CFormPageLayout.vue?vue&type=template&id=3e0a3063&scoped=true&"
import script from "./CFormPageLayout.vue?vue&type=script&lang=ts&"
export * from "./CFormPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CFormPageLayout.vue?vue&type=style&index=0&id=3e0a3063&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a3063",
  null
  
)

export default component.exports